import { getCategoryLabel } from '@koob/travel-diary-content/src/categories';
import ExportFlowPage from './ExportFlowPage';
import { sanitizeDiaryHtml } from '../richText';

export function groupContentsByCategory(contents) {
  const byCategory = new Map();

  (contents ?? []).forEach((content) => {
    const { id, code, displayOrder } = content?.category ?? {};
    if (!id) return;

    if (!byCategory.has(id)) {
      byCategory.set(id, {
        id,
        label: getCategoryLabel(code),
        displayOrder: displayOrder ?? 0,
        items: [],
      });
    }
    byCategory.get(id).items.push(content);
  });

  return [...byCategory.values()]
    .sort((a, b) => a.displayOrder - b.displayOrder)
    .map((category) => ({
      ...category,
      items: [...category.items].sort(
        (a, b) => (a.displaySequence ?? 0) - (b.displaySequence ?? 0),
      ),
    }));
}

export default function ExportContents({
  trip,
  tourOperator,
  settings,
  category,
}) {
  return (
    <ExportFlowPage
      title={category.label}
      trip={trip}
      tourOperator={tourOperator}
      settings={settings}
      footerStatus
    >
      {category.items.map((item) => (
        <div key={item.id} className="mt-6 first:mt-4">
          <div className="text-sm font-semibold uppercase tracking-wide text-[var(--td-ink)]">
            {item.title}
          </div>

          <div
            className="export-rich-text mt-2 text-sm leading-relaxed text-[var(--td-ink-soft)]"
            dangerouslySetInnerHTML={{
              __html: sanitizeDiaryHtml(item.description),
            }}
          />
        </div>
      ))}
    </ExportFlowPage>
  );
}
